<template>
  <div>
    <b-form>
      <b-card>
        <b-card-header class="pt-0">
          <span class="h3">Input</span>
        </b-card-header>
        <b-card-body class="pb-0">
          <b-row>
            <b-col xl="12" lg="12" sm="12">
              <b-input-group class="mb-3" prepend="ICCID" label-for="iccidInfo" :state="iccidState">
                <b-form-input
                    id="iccidInfo"
                    placeholder="Ex: 89018101604000012172"
                    :state="iccidState"
                    v-model="iccidInfo"
                    trim
                    readonly="readonly"
                ></b-form-input>
                <b-form-invalid-feedback :state="iccidState">
                  Please enter a valid iccid.
                </b-form-invalid-feedback>
              </b-input-group>

              <b-input-group prepend="IMSI" class="mb-3" label-for="imsiInfo" :state="imsiState">
                <b-form-input
                    id="imsiInfo"
                    placeholder="Ex: 311240000100019"
                    :state="imsiState"
                    v-model="addSubscriberForm.imsi"
                    trim
                    readonly="readonly"
                ></b-form-input>
                <b-form-invalid-feedback :state="imsiState">
                  Please enter a valid imsi.
                </b-form-invalid-feedback>
              </b-input-group>

              <b-input-group prepend="MSISDN" class="mb-3" label-for="msisdnInfo" :state="msisdnState">
                <b-form-input
                    v-if="isMSISDNInput"
                    id="msisdnInfo"
                    placeholder="Ex: 18889990000"
                    :state="msisdnState"
                    v-model="addSubscriberForm.msisdn"
                    trim
                ></b-form-input>
                <b-form-select
                    v-else
                    id="msisdnInfo"
                    placeholder="Ex: 18889990000"
                    :state="msisdnState"
                    v-model="addSubscriberForm.msisdn"
                    :options="msisdnOption"
                    value-field="value"
                    text-field="key"
                    disabled-field="notEnabled"
                ></b-form-select>
                <b-badge
                    variant="success"
                    class="ml-1 mb-1 cursor-pointer bg-green text-white p-3"
                    v-on:click="toggleMSISDNInput"
                >
                  <i class="fa fa-plus text-white mx-auto"></i>
                </b-badge>
                <b-form-invalid-feedback :state="msisdnState">
                  Please enter a valid msisdn.
                </b-form-invalid-feedback>
              </b-input-group>
              <b-input-group
                  prepend="Select Product"
                  class="mb-3"
                  label-for="hlrProfileInfo"
                  :state="hlrProfileState"
              >
                <b-form-select
                    id="hlrProfileInfo"
                    v-model="addSubscriberForm.product"
                    :options="hlrProfileOption"
                    :state="hlrProfileState"
                    value-field="key"
                    text-field="value"
                    size="md"
                    disabled-field="notEnabled"
                >
                </b-form-select>
                <b-form-invalid-feedback :state="hlrProfileState">
                  Please enter a valid Product.
                </b-form-invalid-feedback>
              </b-input-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <hr/>
      <b-row class="mt-3">
        <b-col xl="6" md="6" sm="6">
          <div class="float-left">
            &nbsp;
            <!--            <base-button type="primary" title="Submit" v-on:click="closeModal">-->
            <!--              Close-->
            <!--            </base-button>-->
          </div>
        </b-col>
        <b-col xl="6" md="6" sm="6">
          <div class="float-right">
            <base-button type="primary" title="Submit" v-on:click="activateSubscriberSubmit">
              Submit
            </base-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import searchDashboardService from "../../common/api-services/search-dashboard-service";
import provisioningService from "../../common/api-services/provisioning-service";
import commonService from "../../common/api-services/common";
import ToastVue from "./Toast.vue";

export default {
  name: "activate_subscriber_simple",
  components: {ToastVue},
  computed: {
    //validators https://www.npmjs.com/package/node-input-validator or https://express-validator.github.io/docs/
    //https://regex101.com/codegen?language=javascript
    iccidState() {
      return commonService.validationCheck("ICCID", this.iccidInfo);
    },
    imsiState() {
      return commonService.validationCheck("IMSI", this.addSubscriberForm.imsi);
    },
    msisdnState() {
      return commonService.validationCheck("MSISDN", this.addSubscriberForm.msisdn);
    },
    hlrProfileState() {
      return commonService.validationCheck("HLRPROFILE", this.addSubscriberForm.product);
    },
  },

  data() {
    return {
      lastMessage: "",
      progressStartValue: 5,
      iccidInfo: "",
      addSubscriberForm: {
        imsi: "",
        msisdn: "",
        product: "",
      },
      isMSISDNInput: false,
      enableDataStatus: false,
      localDataStatus: false,
      msisdnOption: [],
      hssProfileOption: [],
      hlrProfileOption: [],
      dataPlanOption: [],
      timer: null,
      progressTitle: null,
      progressMessage: null,
    };
  },
  mounted() {
    this.setProgressTimer();
    this.$root.$on("sendIMSIInfo", imsi => {
      this.addSubscriberForm.imsi = imsi;
      this.getHlrProfiles();
      this.getMsisdnList(imsi);
    });

    this.$root.$on("sendICCIDInfo", iccid => {
      this.iccidInfo = iccid;
    });
    this.$root.$on("sendMSISDNList", msisdnList => {
      this.msisdnOption += msisdnList.map(item => {
        return {key: item, value: item};
      });
    });
  },

  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },

  methods: {
    toggleMSISDNInput() {
      this.addSubscriberForm.msisdn = this.msisdnOption[0].value;
      this.isMSISDNInput = !this.isMSISDNInput;
      if (this.isMSISDNInput) this.addSubscriberForm.msisdn = "";
    },
    validateData() {
      let errors = [];
      if (!commonService.validationCheck("IMSI", this.addSubscriberForm.imsi)) errors.push("INVALID IMSI");
      if (!commonService.validationCheck("MSISDN", this.addSubscriberForm.msisdn)) errors.push("INVALID MSISDN");
      if (!commonService.validationCheck("HLRPROFILE", this.addSubscriberForm.product))
        errors.push("INVALID PRODUCT");
      return errors;
    },

    setProgressTimer() {
      this.timer = setInterval(() => {
        this.progressStartValue = this.progressStartValue + (Math.random() * 300) / this.progressStartValue;
        if (this.progressStartValue > 100) {
          this.progressStartValue = 10;
        }
      }, 1000);
    },
    getHlrProfiles() {
      let items = [];
      items.push({key: "", value: "Not Set"});
      searchDashboardService.getHlrProfileSelectOption().then(res1 => {
        res1.map(item => {
          if (item.product !== "") items.push({key: item.product, value: item.description});
        });
        this.hlrProfileOption = items;
      });
      this.addSubscriberForm.product = items[0].key;
    },
    getMsisdnList(imsi) {
      let items = [];
      items.push({key: "Use IMSI", value: imsi});
      provisioningService.getMsisdnList().then(res => {
        if (res[0].includes("NOTICE")) return;
        res.forEach(item => {
          items.push({key: item, value: item});
        });
      });
      this.msisdnOption = items;
      this.addSubscriberForm.msisdn = items[0].value;
    },

    activateSubscriberSubmit() {

      //if (configDirective.isIOTOnly()) {
      provisioningService.submitSimpleActivate(this.addSubscriberForm).then(res => {
        if (res) {
          this.$toast.success({
            component: ToastVue,
            props: {
              title: 'Activate Subscriber: OK',
              description: res.join("<br>")
            }
          }, {
            timeout: 45000
          })
          this.closeModal();
        } else {
          this.$toast.error({
            component: ToastVue,
            props: {
              title: 'Activate Subscriber: FAILED',
              description: res.join("<br>")
            }
          }, {
            timeout: 45000
          })
        }
      }).catch(err => {
        this.$toast.error({
          component: ToastVue,
          props: {
            title: 'Activate Subscriber: FAILED',
            description: JSON.stringify(err)
          }
        }, {
          timeout: 45000
        })
      });
      this.closeModal();

    },

    closeModal() {
      setTimeout(() => {
        this.progressMessage = "Refreshing Subscriber data...";

        //window.location.reload();
        this.$forceUpdate();

        this.$root.$emit("reloadSimDetailPageData", this.addSubscriberForm.imsiInfo);
        this.$bvModal.hide("activate-subscriber-simple");

      }, 1000);
    },

  },
};
</script>
